<template>
    <common-content-spacer height="medium">
        <common-content-spacer height="small">
            <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>

            <common-page-header :heading="pageTitle"></common-page-header>
        </common-content-spacer>

        <common-loader :isProcessing="isSending"></common-loader>
        <common-page-plain v-if="referrals.length && !isSending">
            <common-content-spacer height="medium">
                <referrals-pool-index-listing
                    :referrals="referrals"
                    :isFromPatient="isFromPatient"
                    :type="$route.params.type"
                    :filterOptions="[]"
                ></referrals-pool-index-listing>
                <common-buttons>
                    <common-button
                        v-if="referrals.length < referralsTotalCount"
                        :isProcessing="isProcessing"
                        :label="$t('pages.referrals.index.buttons.show_more')"
                        type="primary"
                        size="large"
                        @click="showMore()"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-page-plain>
        <div v-if="!referrals.length && !isSending">{{ $t('pages.referrals.index.empty_state.no_referrals') }}</div>
    </common-content-spacer>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import ReferralsPoolIndexListing from 'components/page-elements/referrals/ReferralsPoolIndexListing'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],

        components: {
            ReferralsPoolIndexListing,
        },

        props: {
            isFromPatient: { type: Boolean, required: false, default: false },
        },

        data() {
            return {
                referrals: [],
                offset: 0,
                referralsTotalCount: 0,
                isSending: false,
                isProcessing: false,
            }
        },

        provide() {
            return {
                isReferralPool: !!this.$route.params.type,
            }
        },

        computed: {
            pageTitle() {
                return this.$t(`pages.referrals.index.titles.${this.$route.params.type}`)
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.referrals.pool.breadcrumbs.referrals'),
                        route: { name: `referrals.${this.$route.params.type}.pool` },
                    },
                    { label: this.$t(`pages.referrals.index.breadcrumbs.${this.$route.params.type}`) },
                ]
            },
        },

        methods: {
            getUserOrPracticeId() {
                if (this.$auth.isPracticeAncillary()) {
                    return this.$auth.getPractice().id
                } else {
                    return this.$auth.getActiveMember() && this.$auth.getActiveMember()?.id
                        ? this.$auth.getActiveMember()?.id
                        : this.$auth.getUser().id
                }
            },

            showMore() {
                this.offset = this.offset + Number(this.$route.query.limit)
                this.getReferralsPool(true)
            },

            getReferralsPool(append) {
                if (!append) {
                    this.isSending = true
                } else {
                    this.isProcessing = true
                }
                ReferralsPoolAPI.getReferralsPool(this.$route.params.type, this.getUserOrPracticeId(), {
                    ...this.$route.query,
                    offset: this.offset,
                    isFromPatient: this.isFromPatient ? this.isFromPatient : undefined,
                })
                    .then((response) => {
                        if (append) {
                            this.referrals = this.referrals.concat(response)
                            return
                        }
                        this.referralsTotalCount = response._headers['x-total-count']
                        this.referrals = response
                    })
                    .finally(() => {
                        this.isSending = false
                        this.isProcessing = false
                    })
            },
        },

        watch: {
            referrals() {
                if (this.referrals._headers) {
                    this.referralsTotalCount = this.referrals._headers['x-total-count']
                }
            },

            '$route.params.tabType'() {
                this.referrals = []
                this.offset = 0
                this.getReferralsPool()
            },

            '$route.params.type'() {
                this.referrals = []
                this.offset = 0
                this.getReferralsPool()
            },
        },

        mounted() {
            this.referrals = []
            this.offset = 0
            this.getReferralsPool()
        },
    }
</script>
